"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BackInStockNotification = require("./BackInStockNotification");
Object.keys(_BackInStockNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BackInStockNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BackInStockNotification[key];
    }
  });
});
var _BasketBubble = require("./BasketBubble");
Object.keys(_BasketBubble).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasketBubble[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasketBubble[key];
    }
  });
});
var _BasketProvider = require("./BasketProvider");
Object.keys(_BasketProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BasketProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BasketProvider[key];
    }
  });
});
var _ErrorNotification = require("./ErrorNotification");
Object.keys(_ErrorNotification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorNotification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorNotification[key];
    }
  });
});
var _FeedbackBenefitDialog = require("./FeedbackBenefitDialog");
Object.keys(_FeedbackBenefitDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FeedbackBenefitDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FeedbackBenefitDialog[key];
    }
  });
});
var _LoyaltyDialog = require("./LoyaltyDialog");
Object.keys(_LoyaltyDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoyaltyDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoyaltyDialog[key];
    }
  });
});
var _MiniShoppingBag = require("./MiniShoppingBag");
Object.keys(_MiniShoppingBag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MiniShoppingBag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MiniShoppingBag[key];
    }
  });
});
var _NovageSkincareAdvisor = require("./NovageSkincareAdvisor");
Object.keys(_NovageSkincareAdvisor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NovageSkincareAdvisor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NovageSkincareAdvisor[key];
    }
  });
});
var _ProductInfoDialog = require("./ProductInfoDialog");
Object.keys(_ProductInfoDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductInfoDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductInfoDialog[key];
    }
  });
});
var _QrCodeDialog = require("./QrCodeDialog");
Object.keys(_QrCodeDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QrCodeDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QrCodeDialog[key];
    }
  });
});
var _RatingAndReviewDialog = require("./RatingAndReviewDialog");
Object.keys(_RatingAndReviewDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RatingAndReviewDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RatingAndReviewDialog[key];
    }
  });
});
var _SubscriptionWizard = require("./SubscriptionWizard");
Object.keys(_SubscriptionWizard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscriptionWizard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscriptionWizard[key];
    }
  });
});
